// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"243":"bed984ddf5bd38e0","835":"bbd8491e2163ebed"}[chunkId] + ".css";
};